import Icon from '@components/v2/ui/Icon/Icon';
import { Box } from '@mui/material';
import { ChevronDown } from 'lucide-react';

interface ExpandableToggleProps {
  isOpen: boolean;
  onClick?: () => void;
}

const ExpandableToggle = ({ isOpen, onClick }: ExpandableToggleProps) => (
  <Box
    onClick={onClick}
    sx={(theme) => ({
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      color: theme.palette.text.secondary,
      transform: isOpen ? 'rotate(180deg)' : 'none',
      transition: theme.transitions.create('transform'),
    })}
  >
    <Icon icon={ChevronDown} />
  </Box>
);

export default ExpandableToggle;
